export default [
  {
    id: 1,
    orden: 1,
    titulo: 'COMUNICADO IMPORTANTE',
    mensaje: `
      La Contraloría General del Estado (CGE) comunica que debido a la implementación de la nueva versión de Ciudadanía Digital de la AGETIC a partir de las 20:00 horas del 1ro de noviembre hasta las 7:00 horas del 4 de noviembre se suspenderá la modalidad digital en el Sistema de Declaración Jurada de Bienes y Rentas.<br/>
      <br/>Agradecemos su amable comprensión.
      <br/><p style="text-align: end;">La Paz, 31 de octubre de 2024</p>
      <center><img src="https://www.contraloria.gob.bo/wp-content/uploads/2022/02/lapaz.png"></img><center>
    `,
    dialogComunicado: false,
    persistente: true,
    multiComunicado: false,
    ambiente: 0
  },
  {
    id: 2,
    orden: 2,
    titulo: '',
    mensaje: '',
    mensajes: [
      { titulo: 'Comunicado 1', mensaje: 'Detalles del primer comunicado.' },
      { titulo: 'Comunicado 2', mensaje: 'Detalles del segundo comunicado.' },
      { titulo: 'Comunicado 3', mensaje: 'Detalles del tercer comunicado.' },
      { titulo: 'Comunicado 4', mensaje: 'Detalles del cuarto comunicado.' }
    ],
    dialogComunicado: false,
    persistente: true,
    multiComunicado: true,
    ambiente: 0
  },
  {
    id: 3,
    orden: 3,
    titulo: 'NUEVO AVISO',
    mensaje: `
      La CGE informa que el próximo viernes 10 de enero, se realizarán tareas de mantenimiento en el sistema desde las 18:00 hasta las 23:00.<br/>
      <br/>Disculpen las molestias.
      <br/><p style="text-align: end;">La Paz, 9 de enero de 2025</p>
    `,
    dialogComunicado: false,
    persistente: true,
    multiComunicado: false,
    ambiente: 0
  },
  {
    id: 4,
    orden: 4,
    titulo: 'ATENCIÓN',
    mensaje: `
      Para verificar la veracidad de un certificado digital el QR le redireccionará al Sistema de Declaraciones Juradas de Bienes y Rentas de la CGE..<br/>      
    `,
    dialogComunicado: true,
    persistente: false,
    multiComunicado: false,
    ambiente: 0
  }
];



// WEBPACK FOOTER //
// ./src/components/portal/comunicado.mensajes.js